// extracted by mini-css-extract-plugin
export default {"productCarousel":"T0-z"};